import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit'
import applicationContentReducer from './globalLanguage.Slice'
import questionsReducer from './questions.Slice'


export const store = configureStore({
    reducer: {
        questions: questionsReducer,
        applicationContent: applicationContentReducer,
    },
})

export type AppDispatch = typeof store.dispatch
export type RootState = ReturnType<typeof store.getState>
export type AppThunk<ReturnType = void> = ThunkAction<ReturnType, RootState, unknown, Action<string>>
